import { TmCart } from '@/tscapi/model/cart';

export const getShowBagEmpty = (cart: TmCart) => {
    //
    // derive if bag should show 'empty bag' message (it excludes donation)
    //
    let isShowBagEmpty = true;
    if (!cart) {
        isShowBagEmpty = true;
    } else {
        if (cart?.CartLines?.length > 0) {
            //cart has products
            if (cart?.CartLines?.length == 1 && cart?.CartLines[0]?.CartLineItem?.IsDonation) {
                //cart one products but only donation
                isShowBagEmpty = true;
            } else {
                isShowBagEmpty = false;
            }
        } else {
            //cart has data but no products
            isShowBagEmpty = true;
        }
    }
    return isShowBagEmpty;
};

export const cartContainsOnlyDonation = (cart: TmCart) => {
    //
    // derive if any item in cart is a donation
    //
    if (!cart) {
        return false;
    } else {
        if (cart?.CartLines?.length > 0) {
            if (cart?.CartLines?.length == 1 && cart?.CartLines[0]?.CartLineItem?.IsDonation) {
                //cart one products but only donation
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
};
